@use '../../styles/menu' as menu;
@use '../../styles/icon' as icon;
@use '../../styles/text' as text;
@use '../../styles/surface' as surface;
@use '../../styles/typography' as typography;

.trigger {
  outline: none;
}

.content {
  @include menu.menu-content;
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
  max-height: var(--radix-dropdown-menu-content-available-height);

  &.fullWidth {
    width: var(--radix-dropdown-menu-trigger-width);
    min-width: max-content;
  }
}

.item {
  @include menu.menu-item;

  &:has(> .itemIcon:first-child) {
    padding-left: 8px;
  }

  &:has(> .subTriggerChevron) {
    padding-right: 8px;
  }
}

.itemDanger {
  @include menu.menu-item-danger;
}

.itemSelected {
  color: text.$text-accent;
  background-color: surface.$surface-accent-light;

  &[data-highlighted] {
    background-color: surface.$surface-accent-light;
  }
}

.label {
  @include typography.text-s-regular;

  display: flex;
  align-items: center;
  padding: 6px 8px;
  color: text.$text-tertiary;
  user-select: none;
}

.itemSelectedNeutral {
  background-color: surface.$surface-background;
}

.itemIcon {
  @include menu.menu-item-icon;
}

.subTriggerLabel {
  flex: 1;
}

.subTriggerChevron {
  margin-left: auto;
  color: icon.$icon-secondary;
  flex-shrink: 0;
}

.separator {
  @include menu.menu-separator;
}

.toggleItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  width: 100%;
}

.itemCheck {
  color: icon.$icon-accent;
}

.itemIndicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  color: icon.$icon-accent;
  opacity: 0;
  transition: opacity 120ms ease;

  &[data-state='checked'] {
    opacity: 1;
  }

  svg {
    width: 14px;
    height: 14px;
  }
}

.itemIndicatorTrailing {
  margin-left: auto;
}
